import src from "IMAGE";
export default { src, width: 395, height: 270, blurWidth: 0, blurHeight: 0};
